import React from "react";

import { getTranslation } from "../../../helpers/getLanguage";
import "./styles.css";

const TrashHeader = ({ showDeleteButton, showRestoreButton, handleDelete, handleRestore }) => {
  return (
    <div className="trash-header flex justify-space-between align-center">
      <span className="trash-header-title">{getTranslation("Recycle Bin")}</span>

      <div className="trash-actions flex">
        {showRestoreButton && (
          <button className={`trash-restore-button medium flex`} onClick={handleRestore}>
            <span>{getTranslation("RESTORE")}</span>
          </button>
        )}

        {showDeleteButton && (
          <button className={`trash-delete-button medium flex`} onClick={handleDelete}>
            <span>{getTranslation("DELETE")}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default TrashHeader;
